import CardListsSortableCardsContainerController from "../../../card_lists/assets/javascript/card-lists-sortable-cards-container-controller"
import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends CardListsSortableCardsContainerController {
};



// WEBPACK FOOTER //
// ./app/components/milestones/assets/javascript/milestones-cards-container-controller.js